import {Controller} from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ["fileNameLabel", "fileInput"];

  declare fileNameLabelTarget: HTMLSpanElement;
  declare fileInputTarget: HTMLInputElement;

  fileSelected(){
    if (!this.fileInputTarget.files)
        return
    const pdfName = this.fileInputTarget.files[0].name
    this.fileNameLabelTarget.innerHTML = pdfName
  }
}